<!--
  It is use for wrapping pages that will not be shown
  to user when they have logged in such as login, register
  Default to redirect to home page when they try to access
  via a url.
-->
<script lang="ts">
  import { get } from "svelte/store";
  import pageUrl, { redirectTo } from "../PageUrl";
  import {
    isCurrentUserLoaded,
    isLoggedIn,
    currentUserStore,
    userInfoStore,
  } from "../app/store/store-user";

  /**
   * Page will be redirected to redirectUrl if user was logged in.
   */
  export let redirectUrl: string = "";

  function isVerifyEmailPath(path: string) {
    return path.indexOf(pageUrl.REGISTER) !== -1 && path.indexOf("verify_email") !== -1;
  }

  function isPlanTypePath(path: string) {
    return path.indexOf(pageUrl.REGISTER) !== -1 && path.indexOf("account_type") !== -1;
  }

  $: isUserLoaded = $isCurrentUserLoaded;
  $: loggedIn = $isLoggedIn;
  $: userInfo = $userInfoStore;
  $: if (isUserLoaded && loggedIn && userInfo) {
    const user = get(currentUserStore);
    if (user.emailVerified && userInfo.plan) {
      if (redirectUrl) redirectTo(redirectUrl);
    } else if (!user.emailVerified && !isVerifyEmailPath(window.location.pathname)) {
      redirectTo(pageUrl.REGISTER, {page: "verify_email"});
    } else if (!userInfo.plan && !isPlanTypePath(window.location.pathname)) {
      redirectTo(pageUrl.REGISTER, {page: "account_type"});
    }
  }
</script>

<div class:opacity-0={!isUserLoaded}>
  <slot />
</div>
